/** Part C — Estimated End Date (Expected Payoff Date) focused resolution modal. */
import React from 'react';
import { CalendarDays } from 'lucide-react';
import { Input } from '../../ui/input';
import { SingleFieldResolutionModal } from './ResolutionModalBase';

function formatDateForInput(d) {
  if (!d) return '';
  try {
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return '';
    return dt.toISOString().split('T')[0];
  } catch (_e) {
    return '';
  }
}

export default function EstimatedEndDateResolutionModal({ open, onOpenChange, deal, onResolved }) {
  return (
    <SingleFieldResolutionModal
      open={open}
      onOpenChange={onOpenChange}
      deal={deal}
      title="Expected Payoff Date"
      description="The date by which this deal is expected to be paid off. Resolves the Summary tab warning when set."
      icon={<CalendarDays className="h-4 w-4" />}
      fieldKey="estimated_end_date"
      initialValue={formatDateForInput(deal?.estimated_end_date)}
      parse={(v) => (v === '' || v == null ? null : new Date(v).toISOString())}
      isValid={(v) => v === '' || !isNaN(new Date(v).getTime())}
      testidPrefix="resolve-estimated-end-date"
    >
      {({ value, setValue, submitting }) => (
        <div className="space-y-2">
          <label className="text-sm font-medium" htmlFor="resolve-estimated-end-date-input">Date</label>
          <Input
            id="resolve-estimated-end-date-input"
            data-testid="resolve-estimated-end-date-input"
            type="date"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            disabled={submitting}
          />
          <p className="text-xs text-muted-foreground">Leave blank to clear; the warning will re-appear.</p>
        </div>
      )}
    </SingleFieldResolutionModal>
  );
}
